import { render, staticRenderFns } from "./RapidAccessFinalGradeForm.vue?vue&type=template&id=50c20950&scoped=true&"
import script from "./RapidAccessFinalGradeForm.vue?vue&type=script&lang=js&"
export * from "./RapidAccessFinalGradeForm.vue?vue&type=script&lang=js&"
import style0 from "./RapidAccessFinalGradeForm.vue?vue&type=style&index=0&id=50c20950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c20950",
  null
  
)

export default component.exports